import withStyles from '@mui/styles/withStyles';
import React from 'react';
import Drawer from './Drawer';

export default withStyles({})(({ ...props }) => <Drawer showTitleIcon drawerTitle="Cremation Manager" {...props} />);
